export default __webpack_public_path__ + "static/media/35be127b9b1246c124d56967f14672f71599841746585.1fbefda2.webp";